import { app } from '../../../../app';
import { Controller } from './o365-provisioning.controller';

app.component('companyManageApplicationUserProvisioning', {
    bindings: {
        application: '<',
        configurationOverviewDTO: '<',
    },
    controller: Controller,
    templateUrl: require('./o365-provisioning.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/o365-provisioning/o365-provisioning.component.js